import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import Button from "../../../Button";
import Modal from "../../../modal";
import SelectInput from "../../../selectInput";
import DateInput from "../../../dateInput";
import Input from "../../../Input";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import NoData from "../../../noData";
import useInfiniteScroll from "./../../../Hooks/useInfiniteScroll";
import { GetAssets, UpdateAssets } from "../../../../redux/Assets/action";
import { Tooltip } from "antd";
import { validateSellAssetForm } from "../../../../validation/ValidationAssets";
import { getPayment } from "../../../../redux/payment/action";

const ActiveAssetsTable = ({ searchValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const [data, setData] = useState({
    date: null,
    amount: "",
    title: "",
    paymentmethod: "",
    description: "",
    soldtype: false,
    soldinfo: {
      date: null,
      amount: "",
      paymentmethod: "",
    },
  });
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [loading, setLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  // Other states
  const [paymentPage, setPaymentPage] = useState(20);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getAssets = useSelector((state) => state?.Assets?.getAssets?.data);
  const getPaymentData = useSelector(
    (state) => state?.Payment?.getPayment?.data
  );

  const paymentOption = getPaymentData?.map((e) => {
    return {
      lable: e?.paymentmethod,
      value: e?._id,
    };
  });

  const tableData = getAssets?.filter((e) => !e?.soldtype);

  const openModal = (rowIndex) => {
    setCurrentRow(rowIndex);
    const selectedRow = tableData[rowIndex];
    setData({
      date: dayjs(selectedRow?.date).format("DD/MM/YYYY"),
      amount: Number(selectedRow?.amount),
      title: selectedRow?.title,
      paymentmethod: selectedRow?.paymentmethod?._id,
      description: selectedRow?.description,
      soldtype: false,
      soldinfo: {
        date: null,
        amount: "",
        paymentmethod: "",
      },
    });
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      soldinfo: {
        ...prevData.soldinfo,
        [name]: value,
      },
    }));

    if (isSubmit) {
      const validationErrors = validateSellAssetForm({
        ...data,
        soldinfo: {
          ...data.soldinfo,
          [name]: value,
        },
      });
      setErrors(validationErrors);
    }
  };

  const handleDateChange = (date, dateString) => {
    setData((prevData) => ({
      ...prevData,
      soldinfo: {
        ...prevData.soldinfo,
        date: dateString,
      },
    }));

    if (isSubmit) {
      const validationErrors = validateSellAssetForm({
        ...data,
        soldinfo: {
          ...data.soldinfo,
          date: dateString,
        },
      });
      setErrors(validationErrors);
    }
  };

  const fetchMoreOptions = useCallback(() => {
    dispatch(
      getPayment({ page: 1, limit: paymentPage, search: searchValue })
    ).then((res) => {
      if (res?.status === 200) {
        setPaymentPage((prev) => prev + 10);
      }
    });
  }, [dispatch, paymentPage, getPaymentData, searchValue]);

  const tableHeading = {
    no: <div className="ml-5 text-center ">No.</div>,
    title: <div className="w-44 px-2  ">Title</div>,
    date: <div className="text-center ">Date</div>,
    vatAmount: <div className="text-center ">Vat Amount</div>,
    remark: <div className="w-80 px-2">Remark</div>,
    paymentMethod: <div className="text-center px-2">Payment Method</div>,
    btn: <div className="mr-5 text-center "></div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = tableData?.map((e, index) => {
    return {
      no: <div className="ml-5 text-center ">{index + 1}</div>,
      title: <div className="w-44 px-2">{e?.title}</div>,
      date: (
        <div className="text-center ">
          {dayjs(e?.date).format("DD/MM/YYYY")}
        </div>
      ),
      vatAmount: <div className="text-center ">{e?.amount}</div>,
      remark: (
        <Tooltip
          color="white"
          arrow={false}
          placement="bottomLeft"
          title={e?.description}
          overlayInnerStyle={{ color: "black" }}
        >
          <div className="text-nowrap px-2">
            {e?.description.length > 30
              ? `${e?.description.slice(0, 30)}...`
              : e?.description}
          </div>
        </Tooltip>
      ),
      paymentMethod: (
        <div className="text-center px-2">
          {e?.paymentmethod?.paymentmethod}
        </div>
      ),
      btn: (
        <div className="mr-5 text-center">
          <Button
            onClick={() => openModal(index)}
            className={"bg-green text-white w-[120px] h-[50px]"}
            children={"Sell"}
          />
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(
      GetAssets({
        page: filter?.page,
        limit: filter?.limit,
        type: false,
        search: searchValue,
      })
    ).then((res) => {
      if (res?.data?.status === 401) {
        navigate("/");
      }
      if (res?.data?.data?.length === 0) {
        setHasMoreData(false);
      }
    });
  }, [dispatch, navigate, filter, searchValue]);

  const handleApproval = async () => {
    setIsSubmit(true);
    const validationErrors = validateSellAssetForm(data);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        const updatedData = {
          ...data,
          soldtype: true,
          soldinfo: {
            ...data.soldinfo,
            amount: Number(data?.soldinfo?.amount),
          },
        };

        const payload = {
          id: tableData[currentRow]?._id,
          data: updatedData,
        };

        await dispatch(UpdateAssets(payload)).then((res) => {
          if (res?.status === 200) {
            closeModal();
            setLoading(false);
            dispatch(
              GetAssets({
                page: filter?.page,
                limit: filter?.limit,
                type: false,
                search: searchValue,
              })
            );
          } else if (res?.status === 401) {
            setLoading(false);
            navigate("/");
          }
        });
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
        return error;
      }
    }
  };

  return (
    <>
      {tableData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}

      <Modal
        loading={loading}
        modalWidth="w-1/2"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        imgSrc="/images/sellAssets.svg"
        title="Sell Asset"
        btn1="Cancel"
        btn2="Done"
        btnClass={"justify-end"}
        modalContent={
          <div className="grid grid-cols-2 gap-x-5 gap-y-5 text-base font-normal">
            <div>
              <Input
                lableName={"Title"}
                inputType={"text"}
                value={data?.title}
                name={"title"}
                disabled={true}
              />
            </div>

            <div>
              <DateInput
                onChange={handleDateChange}
                value={
                  data?.soldinfo?.date
                    ? dayjs(data?.soldinfo?.date, "DD/MM/YYYY")
                    : null
                }
                name={"date"}
              />
              {errors.date && <div className="text-red-500">{errors.date}</div>}
            </div>

            <div>
              <Input
                lableName={"Amount"}
                inputType={"number"}
                currency={true}
                onChange={handleChange}
                value={data?.soldinfo?.amount}
                name={"amount"}
              />
              {errors.amount && (
                <div className="text-red-500">{errors.amount}</div>
              )}
            </div>

            <div>
              <SelectInput
                lableName={"Payment Method"}
                option={paymentOption}
                onChange={handleChange}
                value={data?.soldinfo?.paymentmethod}
                name={"paymentmethod"}
                fetchMoreOptions={fetchMoreOptions}
              />
              {errors.paymentmethod && (
                <div className="text-red-500">{errors.paymentmethod}</div>
              )}
            </div>
          </div>
        }
        handleBtn2={handleApproval}
      />
    </>
  );
};

export default ActiveAssetsTable;
